import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _47e08a88 = () => interopDefault(import('../../../src/client/pages/web/1-to-1-assessment/index.vue' /* webpackChunkName: "pages/web/1-to-1-assessment/index" */))
const _f146fef6 = () => interopDefault(import('../../../src/client/pages/web/about-think-academy/index.vue' /* webpackChunkName: "pages/web/about-think-academy/index" */))
const _f8d500cc = () => interopDefault(import('../../../src/client/pages/web/about-xes/index.vue' /* webpackChunkName: "pages/web/about-xes/index" */))
const _0057199f = () => interopDefault(import('../../../src/client/pages/web/aboutus/index.vue' /* webpackChunkName: "pages/web/aboutus/index" */))
const _8d8d1d12 = () => interopDefault(import('../../../src/client/pages/web/acceptable-use-policy/index.vue' /* webpackChunkName: "pages/web/acceptable-use-policy/index" */))
const _0a74eaed = () => interopDefault(import('../../../src/client/pages/web/activated-page/index.vue' /* webpackChunkName: "pages/web/activated-page/index" */))
const _70689c2a = () => interopDefault(import('../../../src/client/pages/web/application-transfer/index.vue' /* webpackChunkName: "pages/web/application-transfer/index" */))
const _1597cf64 = () => interopDefault(import('../../../src/client/pages/web/assessment/index.vue' /* webpackChunkName: "pages/web/assessment/index" */))
const _25c500a0 = () => interopDefault(import('../../../src/client/pages/web/career/index.vue' /* webpackChunkName: "pages/web/career/index" */))
const _d5594e6a = () => interopDefault(import('../../../src/client/pages/web/child-privacy/index.vue' /* webpackChunkName: "pages/web/child-privacy/index" */))
const _7f5e4dfd = () => interopDefault(import('../../../src/client/pages/web/commerce/index.vue' /* webpackChunkName: "pages/web/commerce/index" */))
const _2c37e9d2 = () => interopDefault(import('../../../src/client/pages/web/cookies-policy/index.vue' /* webpackChunkName: "pages/web/cookies-policy/index" */))
const _32a69422 = () => interopDefault(import('../../../src/client/pages/web/course-material-fee-policy/index.vue' /* webpackChunkName: "pages/web/course-material-fee-policy/index" */))
const _2200de2c = () => interopDefault(import('../../../src/client/pages/web/courses/index.vue' /* webpackChunkName: "pages/web/courses/index" */))
const _2abdb76a = () => interopDefault(import('../../../src/client/pages/web/download/index.vue' /* webpackChunkName: "pages/web/download/index" */))
const _9c0a86ec = () => interopDefault(import('../../../src/client/pages/web/faq/index.vue' /* webpackChunkName: "pages/web/faq/index" */))
const _252b9e81 = () => interopDefault(import('../../../src/client/pages/web/home/index.vue' /* webpackChunkName: "pages/web/home/index" */))
const _812f7b2e = () => interopDefault(import('../../../src/client/pages/web/internet-safety-tips/index.vue' /* webpackChunkName: "pages/web/internet-safety-tips/index" */))
const _a3061ac6 = () => interopDefault(import('../../../src/client/pages/web/level-test/index.vue' /* webpackChunkName: "pages/web/level-test/index" */))
const _7ed96fdc = () => interopDefault(import('../../../src/client/pages/web/locations/index.vue' /* webpackChunkName: "pages/web/locations/index" */))
const _948f59a4 = () => interopDefault(import('../../../src/client/pages/web/my-account/index.vue' /* webpackChunkName: "pages/web/my-account/index" */))
const _63b16a56 = () => interopDefault(import('../../../src/client/pages/web/my-class-transfer/index.vue' /* webpackChunkName: "pages/web/my-class-transfer/index" */))
const _6169c059 = () => interopDefault(import('../../../src/client/pages/web/my-class-transfer-bm/index.vue' /* webpackChunkName: "pages/web/my-class-transfer-bm/index" */))
const _63e9fe2f = () => interopDefault(import('../../../src/client/pages/web/pdf-viewer/index.vue' /* webpackChunkName: "pages/web/pdf-viewer/index" */))
const _592f38c1 = () => interopDefault(import('../../../src/client/pages/web/personal-information/index.vue' /* webpackChunkName: "pages/web/personal-information/index" */))
const _4f1dc17b = () => interopDefault(import('../../../src/client/pages/web/pricing-policy/index.vue' /* webpackChunkName: "pages/web/pricing-policy/index" */))
const _b174d7c2 = () => interopDefault(import('../../../src/client/pages/web/privacy-notice/index.vue' /* webpackChunkName: "pages/web/privacy-notice/index" */))
const _054e0c0e = () => interopDefault(import('../../../src/client/pages/web/privacy-policy/index.vue' /* webpackChunkName: "pages/web/privacy-policy/index" */))
const _7a892e1b = () => interopDefault(import('../../../src/client/pages/web/refund-policy/index.vue' /* webpackChunkName: "pages/web/refund-policy/index" */))
const _1cbb2219 = () => interopDefault(import('../../../src/client/pages/web/resources/index.vue' /* webpackChunkName: "pages/web/resources/index" */))
const _29cd792e = () => interopDefault(import('../../../src/client/pages/web/safeguarding-policy/index.vue' /* webpackChunkName: "pages/web/safeguarding-policy/index" */))
const _3e2dabd9 = () => interopDefault(import('../../../src/client/pages/web/shopping-cart/index.vue' /* webpackChunkName: "pages/web/shopping-cart/index" */))
const _7b6bd43f = () => interopDefault(import('../../../src/client/pages/web/short-term-course/index.vue' /* webpackChunkName: "pages/web/short-term-course/index" */))
const _7b181a60 = () => interopDefault(import('../../../src/client/pages/web/student-portal/index.vue' /* webpackChunkName: "pages/web/student-portal/index" */))
const _64d510c9 = () => interopDefault(import('../../../src/client/pages/web/subscription-manage/index.vue' /* webpackChunkName: "pages/web/subscription-manage/index" */))
const _7ecd803b = () => interopDefault(import('../../../src/client/pages/web/success-page/index.vue' /* webpackChunkName: "pages/web/success-page/index" */))
const _71df9873 = () => interopDefault(import('../../../src/client/pages/web/teachers/index.vue' /* webpackChunkName: "pages/web/teachers/index" */))
const _03e0f6d6 = () => interopDefault(import('../../../src/client/pages/web/terms-and-conditions/index.vue' /* webpackChunkName: "pages/web/terms-and-conditions/index" */))
const _34f2c78e = () => interopDefault(import('../../../src/client/pages/web/terms-of-use/index.vue' /* webpackChunkName: "pages/web/terms-of-use/index" */))
const _3b23e1a0 = () => interopDefault(import('../../../src/client/pages/web/uk-tax-strategy/index.vue' /* webpackChunkName: "pages/web/uk-tax-strategy/index" */))
const _eae047ac = () => interopDefault(import('../../../src/client/pages/web/user-agreement/index.vue' /* webpackChunkName: "pages/web/user-agreement/index" */))
const _f9747540 = () => interopDefault(import('../../../src/client/pages/web/application-transfer/application-records/index.vue' /* webpackChunkName: "pages/web/application-transfer/application-records/index" */))
const _24e421cf = () => interopDefault(import('../../../src/client/pages/web/application-transfer/rules.vue' /* webpackChunkName: "pages/web/application-transfer/rules" */))
const _97a1568a = () => interopDefault(import('../../../src/client/pages/web/careers/job-listings/index.vue' /* webpackChunkName: "pages/web/careers/job-listings/index" */))
const _2dfb37b7 = () => interopDefault(import('../../../src/client/pages/web/courses/list/index.vue' /* webpackChunkName: "pages/web/courses/list/index" */))
const _0f35df92 = () => interopDefault(import('../../../src/client/pages/web/courses/list-bm/index.vue' /* webpackChunkName: "pages/web/courses/list-bm/index" */))
const _2afcec75 = () => interopDefault(import('../../../src/client/pages/web/download/config.js' /* webpackChunkName: "pages/web/download/config" */))
const _8d3595fe = () => interopDefault(import('../../../src/client/pages/web/my-class-transfer/order-acknowledgement/index.vue' /* webpackChunkName: "pages/web/my-class-transfer/order-acknowledgement/index" */))
const _faba5f0c = () => interopDefault(import('../../../src/client/pages/web/my-class-transfer/rules.vue' /* webpackChunkName: "pages/web/my-class-transfer/rules" */))
const _faee0b5a = () => interopDefault(import('../../../src/client/pages/web/my-coupons/history/index.vue' /* webpackChunkName: "pages/web/my-coupons/history/index" */))
const _3d53d515 = () => interopDefault(import('../../../src/client/pages/web/my-coupons/list/index.vue' /* webpackChunkName: "pages/web/my-coupons/list/index" */))
const _14f7530a = () => interopDefault(import('../../../src/client/pages/web/my-courses/list/index.vue' /* webpackChunkName: "pages/web/my-courses/list/index" */))
const _43651411 = () => interopDefault(import('../../../src/client/pages/web/my-subscription/list/index.vue' /* webpackChunkName: "pages/web/my-subscription/list/index" */))
const _3309107e = () => interopDefault(import('../../../src/client/pages/web/my-unpaid-courses/list/index.vue' /* webpackChunkName: "pages/web/my-unpaid-courses/list/index" */))
const _535f0572 = () => interopDefault(import('../../../src/client/pages/web/my-wish/list/index.vue' /* webpackChunkName: "pages/web/my-wish/list/index" */))
const _a5f149be = () => interopDefault(import('../../../src/client/pages/web/order/list/index.vue' /* webpackChunkName: "pages/web/order/list/index" */))
const _449e2f71 = () => interopDefault(import('../../../src/client/pages/web/personal-information/external-bind/index.vue' /* webpackChunkName: "pages/web/personal-information/external-bind/index" */))
const _e37263ce = () => interopDefault(import('../../../src/client/pages/web/question-wiki/home/index.vue' /* webpackChunkName: "pages/web/question-wiki/home/index" */))
const _9f6c4a88 = () => interopDefault(import('../../../src/client/pages/web/shopping-cart/ConfirmDelDialog.vue' /* webpackChunkName: "pages/web/shopping-cart/ConfirmDelDialog" */))
const _0a137faf = () => interopDefault(import('../../../src/client/pages/web/shopping-cart/OfferDetails.vue' /* webpackChunkName: "pages/web/shopping-cart/OfferDetails" */))
const _2b7d40eb = () => interopDefault(import('../../../src/client/pages/web/test/recommended-courses/index.vue' /* webpackChunkName: "pages/web/test/recommended-courses/index" */))
const _2c2e7968 = () => interopDefault(import('../../../src/client/pages/web/test/test-results/index.vue' /* webpackChunkName: "pages/web/test/test-results/index" */))
const _5c64c326 = () => interopDefault(import('../../../src/client/pages/web/courses/detail-bm/FirstClass.vue' /* webpackChunkName: "pages/web/courses/detail-bm/FirstClass" */))
const _4ac074c0 = () => interopDefault(import('../../../src/client/pages/web/courses/detail/FirstClass.vue' /* webpackChunkName: "pages/web/courses/detail/FirstClass" */))
const _60214a69 = () => interopDefault(import('../../../src/client/pages/web/order/shopping-cart/create/index.vue' /* webpackChunkName: "pages/web/order/shopping-cart/create/index" */))
const _c63c5806 = () => interopDefault(import('../../../src/client/pages/web/activity/group/detail/_id.vue' /* webpackChunkName: "pages/web/activity/group/detail/_id" */))
const _128fb80f = () => interopDefault(import('../../../src/client/pages/web/courses/detail-bm/promote/_packageId.vue' /* webpackChunkName: "pages/web/courses/detail-bm/promote/_packageId" */))
const _5745a089 = () => interopDefault(import('../../../src/client/pages/web/courses/detail/promote/_packageId.vue' /* webpackChunkName: "pages/web/courses/detail/promote/_packageId" */))
const _7b55298c = () => interopDefault(import('../../../src/client/pages/web/my-courses/recorded-courses/detail/_skuId.vue' /* webpackChunkName: "pages/web/my-courses/recorded-courses/detail/_skuId" */))
const _0f4a2dc8 = () => interopDefault(import('../../../src/client/pages/web/my-courses/recorded-courses/video/_skuId.vue' /* webpackChunkName: "pages/web/my-courses/recorded-courses/video/_skuId" */))
const _920c74ec = () => interopDefault(import('../../../src/client/pages/web/order/detail/edit-address/_id.vue' /* webpackChunkName: "pages/web/order/detail/edit-address/_id" */))
const _ea9a9aa6 = () => interopDefault(import('../../../src/client/pages/web/order/detail/sub/_id.vue' /* webpackChunkName: "pages/web/order/detail/sub/_id" */))
const _40b18882 = () => interopDefault(import('../../../src/client/pages/web/application-transfer/lesson-reschedule/_id.vue' /* webpackChunkName: "pages/web/application-transfer/lesson-reschedule/_id" */))
const _5caf23c1 = () => interopDefault(import('../../../src/client/pages/web/courses/aggregational-detail/_pageId.vue' /* webpackChunkName: "pages/web/courses/aggregational-detail/_pageId" */))
const _573c07bc = () => interopDefault(import('../../../src/client/pages/web/courses/available-classes/_courseId.vue' /* webpackChunkName: "pages/web/courses/available-classes/_courseId" */))
const _637ab5d2 = () => interopDefault(import('../../../src/client/pages/web/courses/detail-bm/_coursesId.vue' /* webpackChunkName: "pages/web/courses/detail-bm/_coursesId" */))
const _3c948f68 = () => interopDefault(import('../../../src/client/pages/web/courses/detail/_coursesId.vue' /* webpackChunkName: "pages/web/courses/detail/_coursesId" */))
const _708c0560 = () => interopDefault(import('../../../src/client/pages/web/courses/recorded-detail/_skuId.vue' /* webpackChunkName: "pages/web/courses/recorded-detail/_skuId" */))
const _e890f662 = () => interopDefault(import('../../../src/client/pages/web/goods/detail/_skuId.vue' /* webpackChunkName: "pages/web/goods/detail/_skuId" */))
const _d87cdb12 = () => interopDefault(import('../../../src/client/pages/web/my-account/edit-student/_id.vue' /* webpackChunkName: "pages/web/my-account/edit-student/_id" */))
const _729d34c6 = () => interopDefault(import('../../../src/client/pages/web/my-class-transfer/class-transfer/_classId.vue' /* webpackChunkName: "pages/web/my-class-transfer/class-transfer/_classId" */))
const _8e68fda6 = () => interopDefault(import('../../../src/client/pages/web/my-class-transfer/lesson-reschedule/_id.vue' /* webpackChunkName: "pages/web/my-class-transfer/lesson-reschedule/_id" */))
const _7b667714 = () => interopDefault(import('../../../src/client/pages/web/my-coupons/detail/_couponId.vue' /* webpackChunkName: "pages/web/my-coupons/detail/_couponId" */))
const _7d510ad9 = () => interopDefault(import('../../../src/client/pages/web/my-courses/detail/_classId.vue' /* webpackChunkName: "pages/web/my-courses/detail/_classId" */))
const _574fbb99 = () => interopDefault(import('../../../src/client/pages/web/my-courses/prepare/_id.vue' /* webpackChunkName: "pages/web/my-courses/prepare/_id" */))
const _681b305c = () => interopDefault(import('../../../src/client/pages/web/my-subscription/cancelSubscription/_id.vue' /* webpackChunkName: "pages/web/my-subscription/cancelSubscription/_id" */))
const _11375528 = () => interopDefault(import('../../../src/client/pages/web/my-subscription/detail/_id.vue' /* webpackChunkName: "pages/web/my-subscription/detail/_id" */))
const _8d281a2a = () => interopDefault(import('../../../src/client/pages/web/my-unpaid-courses/autopay-notice/_status.vue' /* webpackChunkName: "pages/web/my-unpaid-courses/autopay-notice/_status" */))
const _0855759b = () => interopDefault(import('../../../src/client/pages/web/my-unpaid-courses/class-transfer/_skuId.vue' /* webpackChunkName: "pages/web/my-unpaid-courses/class-transfer/_skuId" */))
const _4c21d84c = () => interopDefault(import('../../../src/client/pages/web/order/create-bm/_skuId.vue' /* webpackChunkName: "pages/web/order/create-bm/_skuId" */))
const _2c395588 = () => interopDefault(import('../../../src/client/pages/web/order/create/_skuId.vue' /* webpackChunkName: "pages/web/order/create/_skuId" */))
const _61069c7c = () => interopDefault(import('../../../src/client/pages/web/order/detail/_id.vue' /* webpackChunkName: "pages/web/order/detail/_id" */))
const _053df0c6 = () => interopDefault(import('../../../src/client/pages/web/order/logistics/_orderId.vue' /* webpackChunkName: "pages/web/order/logistics/_orderId" */))
const _149a4ca3 = () => interopDefault(import('../../../src/client/pages/web/order/refund/_id.vue' /* webpackChunkName: "pages/web/order/refund/_id" */))
const _75da7a2c = () => interopDefault(import('../../../src/client/pages/web/order/result/_orderId.vue' /* webpackChunkName: "pages/web/order/result/_orderId" */))
const _73f164fa = () => interopDefault(import('../../../src/client/pages/web/question-wiki/competition/_id.vue' /* webpackChunkName: "pages/web/question-wiki/competition/_id" */))
const _434235e0 = () => interopDefault(import('../../../src/client/pages/web/question-wiki/paper/_id.vue' /* webpackChunkName: "pages/web/question-wiki/paper/_id" */))
const _39ae79c2 = () => interopDefault(import('../../../src/client/pages/web/question-wiki/question/_queId.vue' /* webpackChunkName: "pages/web/question-wiki/question/_queId" */))
const _56d8b31e = () => interopDefault(import('../../../src/client/pages/web/resources/list/_moduleId.vue' /* webpackChunkName: "pages/web/resources/list/_moduleId" */))
const _5952ca58 = () => interopDefault(import('../../../src/client/pages/web/settings/myaddresses/_id.vue' /* webpackChunkName: "pages/web/settings/myaddresses/_id" */))
const _5b1d6770 = () => interopDefault(import('../../../src/client/pages/web/settings/security/_id.vue' /* webpackChunkName: "pages/web/settings/security/_id" */))
const _35d5c7a7 = () => interopDefault(import('../../../src/client/pages/web/subscription-manage/autopay-notice/_status.vue' /* webpackChunkName: "pages/web/subscription-manage/autopay-notice/_status" */))
const _9d36be86 = () => interopDefault(import('../../../src/client/pages/web/teachers/detail/_teacherId.vue' /* webpackChunkName: "pages/web/teachers/detail/_teacherId" */))
const _2a0b9bc6 = () => interopDefault(import('../../../src/client/pages/web/test/exam-recommended-classes/_sessionId.vue' /* webpackChunkName: "pages/web/test/exam-recommended-classes/_sessionId" */))
const _2486f582 = () => interopDefault(import('../../../src/client/pages/web/test/recommended-classes/_redeem.vue' /* webpackChunkName: "pages/web/test/recommended-classes/_redeem" */))
const _087125f4 = () => interopDefault(import('../../../src/client/pages/web/j/_id.vue' /* webpackChunkName: "pages/web/j/_id" */))
const _e882961e = () => interopDefault(import('../../../src/client/pages/web/module-preview/_id.vue' /* webpackChunkName: "pages/web/module-preview/_id" */))
const _530a9626 = () => interopDefault(import('../../../src/client/pages/web/settings/_id.vue' /* webpackChunkName: "pages/web/settings/_id" */))
const _5cc602a4 = () => interopDefault(import('../../../src/client/pages/web/triage-desk/_id.vue' /* webpackChunkName: "pages/web/triage-desk/_id" */))
const _acfffb60 = () => interopDefault(import('../../../src/client/pages/web/_.vue' /* webpackChunkName: "pages/web/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/1-to-1-assessment",
    component: _47e08a88,
    name: "1-to-1-assessment"
  }, {
    path: "/about-think-academy",
    component: _f146fef6,
    name: "about-think-academy"
  }, {
    path: "/about-xes",
    component: _f8d500cc,
    name: "about-xes"
  }, {
    path: "/aboutus",
    component: _0057199f,
    name: "aboutus"
  }, {
    path: "/acceptable-use-policy",
    component: _8d8d1d12,
    name: "acceptable-use-policy"
  }, {
    path: "/activated-page",
    component: _0a74eaed,
    name: "activated-page"
  }, {
    path: "/application-transfer",
    component: _70689c2a,
    name: "application-transfer"
  }, {
    path: "/assessment",
    component: _1597cf64,
    name: "assessment"
  }, {
    path: "/career",
    component: _25c500a0,
    name: "career"
  }, {
    path: "/child-privacy",
    component: _d5594e6a,
    name: "child-privacy"
  }, {
    path: "/commerce",
    component: _7f5e4dfd,
    name: "commerce"
  }, {
    path: "/cookies-policy",
    component: _2c37e9d2,
    name: "cookies-policy"
  }, {
    path: "/course-material-fee-policy",
    component: _32a69422,
    name: "course-material-fee-policy"
  }, {
    path: "/courses",
    component: _2200de2c,
    name: "courses"
  }, {
    path: "/download",
    component: _2abdb76a,
    name: "download"
  }, {
    path: "/faq",
    component: _9c0a86ec,
    name: "faq"
  }, {
    path: "/home",
    component: _252b9e81,
    name: "home"
  }, {
    path: "/internet-safety-tips",
    component: _812f7b2e,
    name: "internet-safety-tips"
  }, {
    path: "/level-test",
    component: _a3061ac6,
    name: "level-test"
  }, {
    path: "/locations",
    component: _7ed96fdc,
    name: "locations"
  }, {
    path: "/my-account",
    component: _948f59a4,
    name: "my-account"
  }, {
    path: "/my-class-transfer",
    component: _63b16a56,
    name: "my-class-transfer"
  }, {
    path: "/my-class-transfer-bm",
    component: _6169c059,
    name: "my-class-transfer-bm"
  }, {
    path: "/pdf-viewer",
    component: _63e9fe2f,
    name: "pdf-viewer"
  }, {
    path: "/personal-information",
    component: _592f38c1,
    name: "personal-information"
  }, {
    path: "/pricing-policy",
    component: _4f1dc17b,
    name: "pricing-policy"
  }, {
    path: "/privacy-notice",
    component: _b174d7c2,
    name: "privacy-notice"
  }, {
    path: "/privacy-policy",
    component: _054e0c0e,
    name: "privacy-policy"
  }, {
    path: "/refund-policy",
    component: _7a892e1b,
    name: "refund-policy"
  }, {
    path: "/resources",
    component: _1cbb2219,
    name: "resources"
  }, {
    path: "/safeguarding-policy",
    component: _29cd792e,
    name: "safeguarding-policy"
  }, {
    path: "/shopping-cart",
    component: _3e2dabd9,
    name: "shopping-cart"
  }, {
    path: "/short-term-course",
    component: _7b6bd43f,
    name: "short-term-course"
  }, {
    path: "/student-portal",
    component: _7b181a60,
    name: "student-portal"
  }, {
    path: "/subscription-manage",
    component: _64d510c9,
    name: "subscription-manage"
  }, {
    path: "/success-page",
    component: _7ecd803b,
    name: "success-page"
  }, {
    path: "/teachers",
    component: _71df9873,
    name: "teachers"
  }, {
    path: "/terms-and-conditions",
    component: _03e0f6d6,
    name: "terms-and-conditions"
  }, {
    path: "/terms-of-use",
    component: _34f2c78e,
    name: "terms-of-use"
  }, {
    path: "/uk-tax-strategy",
    component: _3b23e1a0,
    name: "uk-tax-strategy"
  }, {
    path: "/user-agreement",
    component: _eae047ac,
    name: "user-agreement"
  }, {
    path: "/application-transfer/application-records",
    component: _f9747540,
    name: "application-transfer-application-records"
  }, {
    path: "/application-transfer/rules",
    component: _24e421cf,
    name: "application-transfer-rules"
  }, {
    path: "/careers/job-listings",
    component: _97a1568a,
    name: "careers-job-listings"
  }, {
    path: "/courses/list",
    component: _2dfb37b7,
    name: "courses-list"
  }, {
    path: "/courses/list-bm",
    component: _0f35df92,
    name: "courses-list-bm"
  }, {
    path: "/download/config",
    component: _2afcec75,
    name: "download-config"
  }, {
    path: "/my-class-transfer/order-acknowledgement",
    component: _8d3595fe,
    name: "my-class-transfer-order-acknowledgement"
  }, {
    path: "/my-class-transfer/rules",
    component: _faba5f0c,
    name: "my-class-transfer-rules"
  }, {
    path: "/my-coupons/history",
    component: _faee0b5a,
    name: "my-coupons-history"
  }, {
    path: "/my-coupons/list",
    component: _3d53d515,
    name: "my-coupons-list"
  }, {
    path: "/my-courses/list",
    component: _14f7530a,
    name: "my-courses-list"
  }, {
    path: "/my-subscription/list",
    component: _43651411,
    name: "my-subscription-list"
  }, {
    path: "/my-unpaid-courses/list",
    component: _3309107e,
    name: "my-unpaid-courses-list"
  }, {
    path: "/my-wish/list",
    component: _535f0572,
    name: "my-wish-list"
  }, {
    path: "/order/list",
    component: _a5f149be,
    name: "order-list"
  }, {
    path: "/personal-information/external-bind",
    component: _449e2f71,
    name: "personal-information-external-bind"
  }, {
    path: "/question-wiki/home",
    component: _e37263ce,
    name: "question-wiki-home"
  }, {
    path: "/shopping-cart/ConfirmDelDialog",
    component: _9f6c4a88,
    name: "shopping-cart-ConfirmDelDialog"
  }, {
    path: "/shopping-cart/OfferDetails",
    component: _0a137faf,
    name: "shopping-cart-OfferDetails"
  }, {
    path: "/test/recommended-courses",
    component: _2b7d40eb,
    name: "test-recommended-courses"
  }, {
    path: "/test/test-results",
    component: _2c2e7968,
    name: "test-test-results"
  }, {
    path: "/courses/detail-bm/FirstClass",
    component: _5c64c326,
    name: "courses-detail-bm-FirstClass"
  }, {
    path: "/courses/detail/FirstClass",
    component: _4ac074c0,
    name: "courses-detail-FirstClass"
  }, {
    path: "/order/shopping-cart/create",
    component: _60214a69,
    name: "order-shopping-cart-create"
  }, {
    path: "/activity/group/detail/:id?",
    component: _c63c5806,
    name: "activity-group-detail-id"
  }, {
    path: "/courses/detail-bm/promote/:packageId?",
    component: _128fb80f,
    name: "courses-detail-bm-promote-packageId"
  }, {
    path: "/courses/detail/promote/:packageId?",
    component: _5745a089,
    name: "courses-detail-promote-packageId"
  }, {
    path: "/my-courses/recorded-courses/detail/:skuId?",
    component: _7b55298c,
    name: "my-courses-recorded-courses-detail-skuId"
  }, {
    path: "/my-courses/recorded-courses/video/:skuId?",
    component: _0f4a2dc8,
    name: "my-courses-recorded-courses-video-skuId"
  }, {
    path: "/order/detail/edit-address/:id?",
    component: _920c74ec,
    name: "order-detail-edit-address-id"
  }, {
    path: "/order/detail/sub/:id?",
    component: _ea9a9aa6,
    name: "order-detail-sub-id"
  }, {
    path: "/application-transfer/lesson-reschedule/:id",
    component: _40b18882,
    name: "application-transfer-lesson-reschedule-id"
  }, {
    path: "/courses/aggregational-detail/:pageId?",
    component: _5caf23c1,
    name: "courses-aggregational-detail-pageId"
  }, {
    path: "/courses/available-classes/:courseId?",
    component: _573c07bc,
    name: "courses-available-classes-courseId"
  }, {
    path: "/courses/detail-bm/:coursesId?",
    component: _637ab5d2,
    name: "courses-detail-bm-coursesId"
  }, {
    path: "/courses/detail/:coursesId?",
    component: _3c948f68,
    name: "courses-detail-coursesId"
  }, {
    path: "/courses/recorded-detail/:skuId?",
    component: _708c0560,
    name: "courses-recorded-detail-skuId"
  }, {
    path: "/goods/detail/:skuId?",
    component: _e890f662,
    name: "goods-detail-skuId"
  }, {
    path: "/my-account/edit-student/:id",
    component: _d87cdb12,
    name: "my-account-edit-student-id"
  }, {
    path: "/my-class-transfer/class-transfer/:classId?",
    component: _729d34c6,
    name: "my-class-transfer-class-transfer-classId"
  }, {
    path: "/my-class-transfer/lesson-reschedule/:id?",
    component: _8e68fda6,
    name: "my-class-transfer-lesson-reschedule-id"
  }, {
    path: "/my-coupons/detail/:couponId?",
    component: _7b667714,
    name: "my-coupons-detail-couponId"
  }, {
    path: "/my-courses/detail/:classId?",
    component: _7d510ad9,
    name: "my-courses-detail-classId"
  }, {
    path: "/my-courses/prepare/:id?",
    component: _574fbb99,
    name: "my-courses-prepare-id"
  }, {
    path: "/my-subscription/cancelSubscription/:id?",
    component: _681b305c,
    name: "my-subscription-cancelSubscription-id"
  }, {
    path: "/my-subscription/detail/:id?",
    component: _11375528,
    name: "my-subscription-detail-id"
  }, {
    path: "/my-unpaid-courses/autopay-notice/:status?",
    component: _8d281a2a,
    name: "my-unpaid-courses-autopay-notice-status"
  }, {
    path: "/my-unpaid-courses/class-transfer/:skuId?",
    component: _0855759b,
    name: "my-unpaid-courses-class-transfer-skuId"
  }, {
    path: "/order/create-bm/:skuId?",
    component: _4c21d84c,
    name: "order-create-bm-skuId"
  }, {
    path: "/order/create/:skuId?",
    component: _2c395588,
    name: "order-create-skuId"
  }, {
    path: "/order/detail/:id?",
    component: _61069c7c,
    name: "order-detail-id"
  }, {
    path: "/order/logistics/:orderId?",
    component: _053df0c6,
    name: "order-logistics-orderId"
  }, {
    path: "/order/refund/:id?",
    component: _149a4ca3,
    name: "order-refund-id"
  }, {
    path: "/order/result/:orderId?",
    component: _75da7a2c,
    name: "order-result-orderId"
  }, {
    path: "/question-wiki/competition/:id?",
    component: _73f164fa,
    name: "question-wiki-competition-id"
  }, {
    path: "/question-wiki/paper/:id?",
    component: _434235e0,
    name: "question-wiki-paper-id"
  }, {
    path: "/question-wiki/question/:queId?",
    component: _39ae79c2,
    name: "question-wiki-question-queId"
  }, {
    path: "/resources/list/:moduleId?",
    component: _56d8b31e,
    name: "resources-list-moduleId"
  }, {
    path: "/settings/myaddresses/:id?",
    component: _5952ca58,
    name: "settings-myaddresses-id"
  }, {
    path: "/settings/security/:id?",
    component: _5b1d6770,
    name: "settings-security-id"
  }, {
    path: "/subscription-manage/autopay-notice/:status",
    component: _35d5c7a7,
    name: "subscription-manage-autopay-notice-status"
  }, {
    path: "/teachers/detail/:teacherId?",
    component: _9d36be86,
    name: "teachers-detail-teacherId"
  }, {
    path: "/test/exam-recommended-classes/:sessionId?",
    component: _2a0b9bc6,
    name: "test-exam-recommended-classes-sessionId"
  }, {
    path: "/test/recommended-classes/:redeem?",
    component: _2486f582,
    name: "test-recommended-classes-redeem"
  }, {
    path: "/j/:id?",
    component: _087125f4,
    name: "j-id"
  }, {
    path: "/module-preview/:id?",
    component: _e882961e,
    name: "module-preview-id"
  }, {
    path: "/settings/:id?",
    component: _530a9626,
    name: "settings-id"
  }, {
    path: "/triage-desk/:id?",
    component: _5cc602a4,
    name: "triage-desk-id"
  }, {
    path: "/*",
    component: _acfffb60,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
